export const reduceWithDefault = (state, action, reducers) => {
    const {
        type,
    } = action;

    return reducers[type]
        ? reducers[type](state, action)
        : state
};
